import { Configuration, InteractionRequiredAuthError, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import apiService from '../service/ApiService';

export const msalConfig: Configuration = {
  auth: {
    clientId: 'fd598c5a-f486-4778-843c-401eafa4b7bd', // Your app's client ID from Azure AD
    authority: 'https://login.microsoftonline.com/9f030721-ff46-4ae0-948c-1a382c75452c', // Tenant or common for multi-tenant
    redirectUri: apiService.getHostURL(), // Your app's redirect URI
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'localStorage', // You can use sessionStorage or localStorage
    storeAuthStateInCookie: false, // Set to true for IE 11 or Edge Legacy
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
      logLevel: LogLevel.Info,
    },
  },
};

// Define the scopes you need
export const loginRequest = {
  scopes: ['api://fd598c5a-f486-4778-843c-401eafa4b7bd/loopback', 'User.Read'], // Microsoft Graph API permission
};

export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Resolves a valid access token via MSAL's silent flow. MSAL itself checks the
 * cached token's expiry and transparently refreshes it when needed, so callers
 * should invoke this before every request rather than caching the result themselves.
 */
export async function acquireAccessToken(): Promise<string | null> {
  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  if (!account) {
    return null;
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      account,
      scopes: loginRequest.scopes,
    });
    return response.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({
        scopes: loginRequest.scopes,
      });
    } else {
      console.error('Silent token acquisition failed:', error);
    }
    return null;
  }
}